export default __webpack_public_path__ + "static/media/plus-targets.97c29a57.svg";